/**
 * Tenant Profile Service - Firmenprofil API
 * Verwendet axios für konsistente Error-Handling mit dem Rest der App
 */
import api from './api';

const tenantProfileService = {
  /**
   * Holt das Firmenprofil
   */
  async getProfile() {
    const response = await api.get('/tenant-profile');
    return response.data;
  },

  /**
   * Erstellt ein neues Firmenprofil
   */
  async createProfile(profileData) {
    const response = await api.post('/tenant-profile', profileData);
    return response.data;
  },

  /**
   * Aktualisiert das Firmenprofil
   */
  async updateProfile(profileData) {
    const response = await api.put('/tenant-profile', profileData);
    return response.data;
  },

  /**
   * Lädt ein Logo hoch
   */
  async uploadLogo(file) {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await api.post('/tenant-profile/logo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  /**
   * Löscht das Logo
   */
  async deleteLogo() {
    const response = await api.delete('/tenant-profile/logo');
    return response.data;
  },

  /**
   * Lädt einen Firmenstempel hoch
   */
  async uploadStamp(file) {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await api.post('/tenant-profile/stamp', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  /**
   * Prüft ob das Profil vollständig ist
   */
  async checkComplete() {
    const response = await api.get('/tenant-profile/check-complete');
    return response.data;
  },

  /**
   * Holt das Profil für Dokumente
   */
  async getProfileForDocuments() {
    const response = await api.get('/tenant-profile/for-documents');
    return response.data;
  },

  /**
   * Inkrementiert die Rechnungsnummer
   */
  async getNextInvoiceNumber() {
    const response = await api.post('/tenant-profile/increment-invoice-number');
    return response.data;
  }
};

export default tenantProfileService;
